module.exports = __webpack_public_path__ + "img/radio.eaea0e54.png";